<template>
  <footer id="contact">
    <div class="container">
      <div class="footer-content">
        <div class="footer-about">
          <div class="footer-logo"> ITMaak TechDev </div>
          <p>Votre source d'information pour tout ce qui concerne le développement informatique, les nouvelles technologies et les tendances IT.</p>
          <div class="social-icons">
            <a href="#"><i class="fab fa-twitter"></i></a>
            <a href="#"><i class="fab fa-linkedin-in"></i></a>
            <a href="#"><i class="fab fa-github"></i></a>
            <a href="#"><i class="fab fa-youtube"></i></a>
          </div>
        </div>
        
        <div class="footer-links">
          <h3>Liens rapides</h3>
          <ul>
            <li><a href="#" @click="scrollToSection('home')">Accueil</a></li>
            <li><a href="#" @click="scrollToSection('articles')">Articles</a></li>
            <li><a href="#" @click="scrollToSection('categories')">Catégories</a></li>
            <li><a href="#" @click="scrollToSection('about')">À propos</a></li>
            <li><a href="#" @click="scrollToSection('contact')">Contact</a></li>
          </ul>
        </div>
        
       
      </div>
      
      <div class="copyright">
        <p>&copy; 2026 TechDev News. Tous droits réservés.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter', // Changé de Footer à SiteFooter
  data() {
    return {
      email: ''
    }
  },
  methods: {
    scrollToSection(sectionId) {
      if (this.$route.path !== '/') {
        this.$router.push('/')
        setTimeout(() => {
          this.scrollToElement(sectionId)
        }, 100)
      } else {
        this.scrollToElement(sectionId)
      }
    },
    scrollToElement(elementId) {
      const element = document.getElementById(elementId)
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: 'smooth'
        })
      }
    },
    subscribeNewsletter() {
      if (this.email) {
        alert(`Merci de vous être abonné à notre newsletter avec l'adresse : ${this.email}`)
        this.email = ''
      }
    }
  }
}
</script>

<style scoped>
footer {
  background: var(--dark);
  color: white;
  padding: 60px 0 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-logo {
  font-size: 1.8rem;
  font-weight: 800;
  margin-bottom: 20px;
  color: white;
}

.footer-about p {
  color: #cbd5e1;
  margin-bottom: 20px;
}

.footer-links h3, .footer-newsletter h3 {
  font-size: 1.2rem;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.footer-links h3::after, .footer-newsletter h3::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 3px;
  background: var(--primary);
}

.footer-links ul {
  list-style: none;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #cbd5e1;
  text-decoration: none;
  transition: var(--transition);
  cursor: pointer;
}

.footer-links a:hover {
  color: white;
  padding-left: 5px;
}

.newsletter-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.newsletter-input {
  padding: 12px 15px;
  border-radius: var(--radius);
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.newsletter-input::placeholder {
  color: #94a3b8;
}

.newsletter-btn {
  padding: 12px 15px;
  background: var(--primary);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.newsletter-btn:hover {
  background: var(--primary-dark);
}

.social-icons {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.social-icons a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: white;
  text-decoration: none;
  transition: var(--transition);
}

.social-icons a:hover {
  background: var(--primary);
  transform: translateY(-3px);
}

.copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid #334155;
  color: #94a3b8;
  font-size: 0.9rem;
}
</style>